// extracted by mini-css-extract-plugin
export default {"modalWrapper":"FeedbackModal_modalWrapper__mKLoj","animation":"FeedbackModal_animation__DGtRL"};